import Vue from 'vue';
import Vuex from 'vuex';

import messages from './messages';
import user from './modules/user/index';
import company from './modules/company/index';
import general from './modules/general/index';
import employee from './modules/employee/index';
import subscription from './modules/subscription/index';
import seco from './modules/seco/index';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    messages,
    user,
    company,
    general,
    employee,
    subscription,
    seco,
  },
  strict: debug,
});
